function setBanknumber(str) {
    return str.toString().replace(/[0-9]/g, (x, index) => {
      if (index === 2 || index === 3 || index === 8) return x + '-'
      return x
    })
  }
  export default setBanknumber